import {Injectable} from '@angular/core';

@Injectable({providedIn: 'root'})
export class ToolsService {

    hasOwnProperty = Object.prototype.hasOwnProperty;
    stateOptions: any = [];
    userLevelOptions: any = [];

    // ticket status : confirmed blocked canceled

    isEmpty(obj) {

        // null and undefined are 'empty'
        if (obj == null) {
            return true;
        }

        // Assume if it has a length property with a non-zero value
        // that that property is correct.
        if (obj.length > 0) {
            return false;
        }
        if (obj.length === 0) {
            return true;
        }

        // If it isn't an object at this point
        // it is empty, but it can't be anything *but* empty
        // Is it empty?  Depends on your application.
        if (typeof obj !== 'object') {
            return true;
        }

        // Otherwise, does it have any properties of its own?
        // Note that this doesn't handle
        // toString and valueOf enumeration bugs in IE < 9
        for (const key in obj) {
            if (this.hasOwnProperty.call(obj, key)) {
                return false;
            }
        }

        return true;
    }

    getDimensionsById(array: any, id: number) {
        return array.find(x => x.id === id);
    }

    getStateOptions() {
        const stateLists = {
            'AL': 'Alabama',
            'AK': 'Alaska',
            'AS': 'American Samoa',
            'AZ': 'Arizona',
            'AR': 'Arkansas',
            'CA': 'California',
            'CO': 'Colorado',
            'CT': 'Connecticut',
            'DE': 'Delaware',
            'DC': 'District Of Columbia',
            'FM': 'Federated States Of Micronesia',
            'FL': 'Florida',
            'GA': 'Georgia',
            'GU': 'Guam',
            'HI': 'Hawaii',
            'ID': 'Idaho',
            'IL': 'Illinois',
            'IN': 'Indiana',
            'IA': 'Iowa',
            'KS': 'Kansas',
            'KY': 'Kentucky',
            'LA': 'Louisiana',
            'ME': 'Maine',
            'MH': 'Marshall Islands',
            'MD': 'Maryland',
            'MA': 'Massachusetts',
            'MI': 'Michigan',
            'MN': 'Minnesota',
            'MS': 'Mississippi',
            'MO': 'Missouri',
            'MT': 'Montana',
            'NE': 'Nebraska',
            'NV': 'Nevada',
            'NH': 'New Hampshire',
            'NJ': 'New Jersey',
            'NM': 'New Mexico',
            'NY': 'New York',
            'NC': 'North Carolina',
            'ND': 'North Dakota',
            'MP': 'Northern Mariana Islands',
            'OH': 'Ohio',
            'OK': 'Oklahoma',
            'OR': 'Oregon',
            'PW': 'Palau',
            'PA': 'Pennsylvania',
            'PR': 'Puerto Rico',
            'RI': 'Rhode Island',
            'SC': 'South Carolina',
            'SD': 'South Dakota',
            'TN': 'Tennessee',
            'TX': 'Texas',
            'UT': 'Utah',
            'VT': 'Vermont',
            'VI': 'Virgin Islands',
            'VA': 'Virginia',
            'WA': 'Washington',
            'WV': 'West Virginia',
            'WI': 'Wisconsin',
            'WY': 'Wyoming'
        };
        for (const key in stateLists) {
            this.stateOptions.push({'value': key, 'label': stateLists[key]});
        }
        return this.stateOptions;
    }

    getUserLevelOptions() {
        const userLevels = {
            '1': 'Super Admin', '2': 'Shuttle Admin', '3': 'Sub Agency',
            '4': 'Carrier', '5': 'Resigned Admin', '6': 'Paxbooking', '7': 'Resigned Sub Agency', '8': 'Dormant Account', '9': 'Blocked'
        };
        for (const key in userLevels) {
            this.userLevelOptions.push({'value': key, 'label': userLevels[key]});
        }
        return this.userLevelOptions;
    }

    formatDate(date) {
        // console.log(new Date(date).toISOString());
        return new Date(date).toISOString().substr(0, 10);
        // const d = new Date(date);
        // console.log(d);
        // let month = '' + (d.getMonth() + 1),
        //     day = '' + d.getDate();
        // const year = d.getFullYear();
        // console.log(day);
        // if (month.length < 2) {
        //     month = '0' + month;
        // }
        // if (day.length < 2) {
        //     day = '0' + day;
        // }
        //
        // return [year, month, day].join('-');
    }

}
